import { render } from "./PaymentReceiptDetailTabShipping.vue?vue&type=template&id=7a4ac020"
import script from "./PaymentReceiptDetailTabShipping.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptDetailTabShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__